module.exports = window.jQuery;
